module.exports = window.jQuery;
